/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { FormControl, Button } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';

const defaultProps = {
  value: '',
};

const propTypes = {
  onDelete: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  value: React.PropTypes.string,
};

class DeviceFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.devicefilter');
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  render() {
    const { onDelete, onChange } = this.props;
    const { value } = this.state;

    return (
      <div className={styles.filter}>
        <span className={styles.label}>
          <i className="fa fa-hdd-o" />
        </span>
        <FormControl
          placeholder={this.intlMsg.msg('placeholder')}
          value={value}
          onChange={onChange}
        />
        <Button
          bsStyle="aisz-device"
          className={styles.closeBtn}
          onClick={onDelete}
        >
          <i className="fa fa-times" />
        </Button>
      </div>
    );
  }
}

DeviceFilter.defaultProps = defaultProps;
DeviceFilter.propTypes = propTypes;

export default injectIntl(DeviceFilter);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/DeviceFilter/index.jsx